import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { TipoRespaldo } from '../_models/tipo-respaldo';

@Injectable({
  providedIn: 'root'
})
export class TipoRespaldoService {
  private rutServicio = AppSettings.rutServiciosRG + '/api/tiposRespaldos/';

  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as TipoRespaldo[] ) );
  }

  listadoHabilitado() {
    return this.httpClient.get( this.rutServicio + 'enabled' ).pipe( map( res => res as TipoRespaldo[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( this.rutServicio + id ).pipe( map( res => res as TipoRespaldo ) );
  }

  crear( regCrear: TipoRespaldo ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as TipoRespaldo ) );
  }

  actualizar( regActualizar: TipoRespaldo ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  buscar( str: string ) {
    return this.httpClient.get( this.rutServicio + 'buscar/' + str + '/' ).pipe( map( res => res as TipoRespaldo[] ) );
  }
}
